var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"last-update-info"},[_c('span',{staticClass:"title"},[_vm._v("Last Updated Date & Time:")]),_c('span',{staticClass:"timestamp"},[_vm._v(_vm._s(_vm.timestamp))])])}
var staticRenderFns = []

export { render, staticRenderFns }